import { Box, Typography, useTheme } from "@mui/material";
import { ReactNode } from "react";

export const TileContentGreyBackground = ({
  children,
  minHeight = 120,
}: {
  children: ReactNode;
  minHeight?: number;
}) => {
  const theme = useTheme();
  const isChildrenPrimitive = typeof children !== "object";
  return (
    <Box
      sx={{
        px: 1,
        py: 1,
        minHeight: minHeight,
        textAlign: "center",
        backgroundColor: theme.palette.grey50.main,
        borderRadius: 1,
      }}
    >
      {isChildrenPrimitive ? (
        // Display primitives centered in the box
        <Typography
          variant="body1"
          color="text.primary"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          {children}
        </Typography>
      ) : (
        children
      )}
    </Box>
  );
};
